import Vue from 'vue'
import Vuex from 'vuex';
import router from './router'
import store from './store';
import vuetify from './plugins/vuetify';
import App from './App.vue'
//HTTP client
import axios from 'axios';
import VueAxios from 'vue-axios'
//Theme
import BootstrapVue from "bootstrap-vue"
import Pages from './Layout/Wrappers/pagesLayout.vue';
import setupInterceptors from './services/auth/setupInterceptors';

window.Vue = require('vue').default;

Vue.config.productionTip = false;
Vue.router = router;

Vue.use(VueAxios, axios)
Vue.use(Vuex);
Vue.use(BootstrapVue);

setupInterceptors(store);

Vue.component('userpages-layout', Pages);

//Vue.prototype.$hostname = "http://localhost:8000"
Vue.prototype.$hostname = "https://live.voxpopuli-app.eu"
Vue.prototype.$hostnameImages = "https://live.voxpopuli-app.eu"

const app = new Vue({
    router,
    store,
    vuetify,
    template: '<App/>',
    render: h => h(App)
}).$mount('#app');